module.exports = __webpack_public_path__ + "static/fonts/OpenSans-LightItalic.54b4443.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-LightItalic.ttf
// module id = kkHK
// module chunks = 1